import type { HTMLAttributes } from 'react';
import type { Language as LanguageType } from 'src/generated/graphql-manager';

import styles from './language.module.css';

export type LanguageProps = {
  language: string;
};

export function Language({ language, ...props }: LanguageProps) {
  return (
    <span className={styles.language} {...props}>
      {language}
    </span>
  );
}

export type LanguagesProps = {
  languages: LanguageType[];
} & HTMLAttributes<HTMLDivElement>;

export function Languages({ languages, ...props }: LanguagesProps) {
  return (
    <div className={styles.languages} {...props}>
      {languages.map(({ code }) => (
        <Language key={code} language={code} />
      ))}
    </div>
  );
}
